import { useCallback } from 'react';
import styles from './ConfirmationBox.module.css';
import PrimaryCTA from '../../CTAs/PrimaryCTA/PrimaryCTA';
import SecondaryCTA from '../../CTAs/SecondaryCTA/SecondaryCTA';

/**
 * ConfirmationBox - A reusable confirmation dialog component
 * @param {string} title - Dialog title
 * @param {string} message - Main message text to display
 * @param {string} confirmText - Text for the positive confirmation button
 * @param {function} onConfirm - Callback when user confirms the action
 * @param {function} onCancel - Callback when user cancels or closes dialog
 * @param {boolean} isVisible - Whether the dialog is visible
 */
const ConfirmationBox = ({
    title,
    message,
    confirmText = 'Confirm',
    onConfirm,
    onCancel,
    isVisible = false
}) => {
    const handleConfirm = useCallback(() => {
        if (onConfirm) {
            onConfirm();
        }
    }, [onConfirm]);

    const handleCancel = useCallback(() => {
        if (onCancel) {
            onCancel();
        }
    }, [onCancel]);

    const handleOverlayClick = useCallback((event) => {
        if (event.target === event.currentTarget) {
            handleCancel();
        }
    }, [handleCancel]);

    if (!isVisible) {
        return null;
    }

    return (
        <div className={styles.overlay} onClick={handleOverlayClick}>
            <div className={styles.dialog}>
                <div className={styles.header}>
                    <h3 className={styles.title}>{title}</h3>
                </div>
                <div className={styles.content}>
                    <p className={styles.message}>{message}</p>
                </div>
                <div className={styles.footer}>
                    <SecondaryCTA
                        text="Cancel"
                        onClick={handleCancel}
                        variant="outline"
                    />
                    <PrimaryCTA
                        text={confirmText}
                        onClick={handleConfirm}
                        className={styles.dangerButton}
                    />
                </div>
            </div>
        </div>
    );
};

export default ConfirmationBox;